var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconToteSimple = function SvgIconToteSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.356 5.75a4.75 4.75 0 0 1 9.288 0h4.278a1.75 1.75 0 0 1 1.728 1.945v.002l-1.333 12.01a1.76 1.76 0 0 1-1.737 1.543l-.005-1v1H4.42a1.76 1.76 0 0 1-1.737-1.542l-.002-.013L1.35 7.697v-.001A1.75 1.75 0 0 1 3.078 5.75h4.278m2.7-.945a2.75 2.75 0 0 1 4.506.945H9.438c.137-.35.346-.673.617-.945M3.368 7.75l1.276 11.5h14.712l1.276-11.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconToteSimple;